<template>
  <div class="dapp-navigation">

    <div class="dapp-nav-bar">

      <div class="nav-bar-mobile">
        <a @click="toggleMenu" class="dapp-menu-mobile-button">
          <a-icon type="bars"></a-icon>
        </a>
        <a @click="navigateToHome"><h2 class="dapp-nav-title">DAppChaser</h2></a>
      </div>

      <div class="nav-bar-desktop">
        <!-- Logo -->
        <a @click="navigateToHome">
          <SimpleImage class="dapp-logo"></SimpleImage>
        </a>

        <!-- 桌面端菜单 -->
        <div class="dapp-menu-desktop">
          <ul class="horizontal-menu">
            <li class="primary-menu-item">
              <a @click="navigateToHome">{{ $t('menu.home') }}</a>
            </li>
            <li class="primary-menu-item">
              <a @click="navigateToRanking">{{ $t('menu.ranking') }}</a>
            </li>
            <li class="primary-menu-item">
              <a @click="navigateToBlog">{{ $t('menu.blog') }}</a>
            </li>
            <li class="primary-menu-item">
              <a @click="navigateToSubmit">{{ $t('menu.submit') }}</a>
            </li>
            <li class="primary-menu-item">
              <a @click="navigateToAbout">{{ $t('menu.about') }}</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 空白填充 -->
      <div class="flex-grow-1"></div>

      <!-- 搜索 -->
      <a @click="navigateToSearch" class="dapp-button-search">
        <a-icon type="search"></a-icon>
      </a>

      <!-- 语言 -->
      <div class="dapp-lang">
        <b-dropdown :text="$t('language')" class="m-2">
          <b-dropdown-item v-for="lang in languages" :key="lang.key"
                           @click="setLanguage(lang.key)">{{ lang.name }}
          </b-dropdown-item>
        </b-dropdown>
      </div>

    </div>

    <!-- 移动版菜单 -->
    <div v-if="showMenu" class="dapp-menu-overlay" @click="hideMenu"></div>

    <div class="dapp-menu-mobile" :class="{slideIn: showMenu}">
      <ul class="vertical-menu">
        <li class="primary-menu-item">
          <a @click="navigateToHome">{{ $t('menu.home') }}</a>
        </li>
        <li class="primary-menu-item">
          <a @click="navigateToRanking">{{ $t('menu.ranking') }}</a>
        </li>
        <li class="primary-menu-item">
          <a @click="navigateToBlog">{{ $t('menu.blog') }}</a>
        </li>
        <li class="primary-menu-item">
          <a @click="navigateToSubmit">{{ $t('menu.submit') }}</a>
        </li>
        <li class="primary-menu-item">
          <a @click="navigateToAbout">{{ $t('menu.about') }}</a>
        </li>
        <li class="primary-menu-item">
          <a>{{$t('language')}}</a>
          <ul class="secondary-menu-container">
            <li class="secondary-menu-item" v-for="lang in languages" :key="lang.key">
              <a @click="setLanguage(lang.key)">{{ lang.name }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>

  </div>

</template>

<script>
  import * as lang from '../lang'
  import * as router from '../router'
  import SimpleImage from './SimpleImage'
  import DAppSearchBox from './DAppSearchBox'

  export default {
    name: 'DAppNavigation',
    components: {DAppSearchBox, SimpleImage},
    data () {
      return {
        showMenu: false,
        languages: lang.getLanguageList(),
      }
    },
    methods: {
      toggleMenu () {
        this.showMenu = !this.showMenu
      },
      hideMenu () {
        this.showMenu = false
      },
      navigateToHome () {
        this.hideMenu()
        router.navigateToHome()
      },
      navigateToRanking () {
        this.hideMenu()
        router.navigateToRanking()
      },
      navigateToBlog () {
        this.hideMenu()
        router.navigateToBlog()
      },
      navigateToSubmit () {
        this.hideMenu()
        router.navigateToSubmit()
      },
      navigateToSearch () {
        this.hideMenu()
        router.navigateToSearch()
      },
      navigateToAbout () {
        this.hideMenu()
        router.navigateToAbout()
      },
      setLanguage (l) {
        lang.setLanguage(this, l)
      },
    }
  }
</script>

<style lang="scss" scoped>

  @import "./../utils";

  // 容器
  .dapp-nav-bar {
    top: 0;
    left: 0;
    width: 100%;
    position: fixed;
    z-index: 102;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 0;
    background-color: white;
    box-shadow: 0 5px 15px rgba(30, 30, 30, .05);
  }

  .nav-bar-mobile {
    @include flex-horizontal;
    margin-left: 15px;
    @include respond-desktop {
      display: none;
    }
  }

  .nav-bar-desktop {
    display: none;
    margin-left: 30px;
    @include respond-above(md) {
      @include flex-horizontal;
    }
  }

  .dapp-menu-overlay {
    //@include fade-in;
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 60px;
    z-index: 100;
    @include respond-desktop {
      display: none;
    }
  }

  .dapp-menu-mobile {
    @include slide-from-left;
    position: fixed;
    left: 0;
    top: 60px;
    height: 100%;
    z-index: 101;
    flex-grow: 1;
    background-color: white;
    @include box-shadow($x: 10px, $y: 0);
    @include respond-desktop {
      display: none;
    }
  }

  // 元素
  .dapp-menu-mobile-button {
    padding: 10px;
    line-height: 30px;
    font-size: 30px;
  }

  .dapp-nav-title {
    font-size: 18px;
    padding: 0;
    margin: 0 0 0 5px;
    color: rgba(0, 0, 0, .7);
  }

  .dapp-button-search {
    padding: 10px;
    line-height: 25px;
    font-size: 25px;
    margin-right: 10px;
  }

  .dapp-logo {
    height: 40px;
    width: 40px;
  }

  .dapp-lang {
    margin-right: 30px;
    display: none;
    @include respond-desktop {
      display: block;
    }
  }

</style>



// WEBPACK FOOTER //
// src/widgets/DAppNavigation.vue